import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserDto } from '@/types/api';

type AuthState = {
  token: string | null;
  user: UserDto | null;
  isAuthenticated: boolean;
  setSession: (token: string, user: UserDto) => void;
  setUser: (user: UserDto) => void;
  logout: () => void;
};

/**
 * 鉴权状态切片。
 *
 * 仅持久化 token —— user 信息由后续 me 接口刷新；
 * 这样可以避免 user 字段升级时旧本地缓存失效带来的体验问题。
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      setSession: (token, user) => set({ token, user, isAuthenticated: true }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, user: null, isAuthenticated: false }),
    }),
    {
      name: 'dispatch-auth',
      partialize: (state) => ({ token: state.token }),
      onRehydrateStorage: () => (state) => {
        if (state?.token) {
          state.isAuthenticated = true;
        }
      },
    },
  ),
);
